import React from 'react';

// 랜딩 제품 목업 — 실제 admin 화면(Dashboard.js 메뉴 / 차량 7단계 상태)을 div 로 재현
// 디자인 시스템: docs/design/AUTODEX_DESIGN.md (§2 색상, §4 형태, 폰 목업 글로우는 그림자 금지 예외)
var NAVY = '#1B3A5C';
var BRAND = '#2563eb';
var LINE = '#e3e8ee';
var MUTE = '#64748d';

// 차량 상태 7단계 팔레트 (등록완료 → 말소신청 → 말소완료 → 면장신청 → 면장완료 → 선적대기 → 선적완료)
var STATUS = {
  '등록완료': {bg:'#f1f5f9',c:'#475569'},
  '말소신청': {bg:'#fdf1dc',c:'#9b6829'},
  '말소완료': {bg:'#e8f0fe',c:'#2563eb'},
  '면장신청': {bg:'#ede9fe',c:'#6d28d9'},
  '면장완료': {bg:'#ede9fe',c:'#6d28d9'},
  '선적대기': {bg:'#fdf1dc',c:'#9b6829'},
  '선적완료': {bg:'#e5f5ec',c:'#1e7b45'}
};

var StatusPill = function(p){
  var s = STATUS[p.label] || STATUS['등록완료'];
  return <span style={{fontSize:p.size||9,fontWeight:700,borderRadius:9999,padding:p.size===8?'2px 7px':'3px 9px',background:s.bg,color:s.c,whiteSpace:'nowrap',lineHeight:1.5}}>{p.label}</span>;
};

// 사이드바 아이콘 — 이모지 대신 12px 스트로크 SVG
var MenuIcon = function(p){
  var paths = {
    dash: <g><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></g>,
    add: <g><rect x="3" y="3" width="18" height="18" rx="4"/><path d="M12 8v8M8 12h8"/></g>,
    car: <g><path d="M4 16v-3l2-5h12l2 5v3"/><path d="M3 16h18v3H3z"/><circle cx="7.5" cy="19.5" r="1.2"/><circle cx="16.5" cy="19.5" r="1.2"/></g>,
    doc: <g><path d="M6 3h8l4 4v14H6z"/><path d="M9 12h6M9 16h6"/></g>,
    upload: <g><path d="M4 15v4h16v-4"/><path d="M12 16V4"/><path d="m7 9 5-5 5 5"/></g>,
    tax: <g><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M9 8h6M9 12h2M9 16h2M14 12h1M14 16h1"/></g>,
    gear: <g><circle cx="12" cy="12" r="3.2"/><path d="M12 3v2.4M12 18.6V21M3 12h2.4M18.6 12H21M5.6 5.6l1.7 1.7M16.7 16.7l1.7 1.7M18.4 5.6l-1.7 1.7M7.3 16.7l-1.7 1.7"/></g>
  };
  return <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={p.c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>{paths[p.k]}</svg>;
};

var SearchIcon = function(){
  return <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.2" strokeLinecap="round" style={{flexShrink:0}}><circle cx="10.5" cy="10.5" r="6.5"/><path d="m20 20-4.4-4.4"/></svg>;
};

// 폰 목업 — 앱 차량 목록 화면 (히어로 오브젝트 + 미리보기 보조)
var PhoneMockup = function(){
  var kpis = [{v:'128대',l:'등록 차량'},{v:'42건',l:'진행 서류'},{v:'₩38.2M',l:'이달 매출'}];
  var rows = [
    {no:'142러3821',name:'그랜저 IG',label:'말소완료'},
    {no:'07소7215',name:'쏘나타 DN8',label:'면장신청'},
    {no:'31가5540',name:'아반떼 CN7',label:'선적완료'},
    {no:'86버1097',name:'스포티지 NQ5',label:'등록완료'},
    {no:'223하6634',name:'팰리세이드 LX2',label:'말소신청'}
  ];
  var tabs = [{l:'홈',on:true},{l:'차량',on:false},{l:'서류',on:false},{l:'더보기',on:false}];
  return (
    <div className="lp-phone" style={{position:'relative',width:250,borderRadius:40,background:'#0c0f14',border:'1px solid #262c36',padding:11,boxShadow:'0 -10px 60px rgba(37,99,235,0.25), 0 30px 80px rgba(0,0,0,0.6)'}}>
      <div style={{borderRadius:30,background:'#f6f9fc',color:'#16324f',overflow:'hidden',fontSize:11,display:'flex',flexDirection:'column',minHeight:505}}>
        <div style={{background:NAVY,color:'#fff',padding:'8px 15px 12px'}}>
          <div style={{display:'flex',justifyContent:'center',marginBottom:10}}>
            <span style={{width:64,height:15,borderRadius:9999,background:'#0c0f14'}}></span>
          </div>
          <div style={{fontSize:14,fontWeight:700}}>AUTODEX</div>
          <div style={{fontSize:9,color:'#9db4cd',marginTop:2}}>오늘의 수출 현황</div>
        </div>
        <div style={{display:'flex',gap:6,padding:'10px 10px 4px'}}>
          {kpis.map(function(k,i){return (
            <div key={i} style={{flex:1,minWidth:0,background:'#fff',borderRadius:10,padding:'8px 9px',border:'1px solid '+LINE}}>
              <div style={{fontSize:10.5,fontWeight:700,fontVariantNumeric:'tabular-nums',letterSpacing:'-0.02em',whiteSpace:'nowrap'}}>{k.v}</div>
              <div style={{fontSize:8,color:MUTE,marginTop:1,whiteSpace:'nowrap'}}>{k.l}</div>
            </div>
          )})}
        </div>
        <div style={{padding:'8px 10px 10px',display:'flex',flexDirection:'column',gap:6}}>
          {rows.map(function(r,i){return (
            <div key={i} style={{background:'#fff',border:'1px solid '+LINE,borderRadius:10,padding:'8px 10px',display:'flex',alignItems:'center',gap:8}}>
              <span style={{minWidth:0,flex:1}}>
                <span style={{display:'block',fontSize:11,fontWeight:700,letterSpacing:'-0.01em',fontVariantNumeric:'tabular-nums'}}>{r.no}</span>
                <span style={{display:'block',fontSize:9,color:MUTE,marginTop:1,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{r.name}</span>
              </span>
              <StatusPill label={r.label} size={8} />
            </div>
          )})}
        </div>
        <div style={{display:'flex',borderTop:'1px solid '+LINE,background:'#fff',padding:'7px 6px 10px',marginTop:'auto'}}>
          {tabs.map(function(t,i){return (
            <span key={i} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',gap:3}}>
              <span style={{width:7,height:7,borderRadius:2,background:t.on?BRAND:'#cbd5e1'}}></span>
              <span style={{fontSize:7.5,fontWeight:t.on?700:500,color:t.on?BRAND:'#94a3b8'}}>{t.l}</span>
            </span>
          )})}
        </div>
      </div>
    </div>
  );
};

// 웹 관리자 목업 — 차량 목록 화면 재현 (미리보기 섹션 주인공)
var BrowserMockup = function(){
  var menus = [
    {k:'dash',l:'대시보드'},{k:'add',l:'차량 등록'},{k:'car',l:'차량 목록',on:true},
    {k:'doc',l:'인보이스'},{k:'upload',l:'문서 업로드'},{k:'tax',l:'세무처리'}
  ];
  var kpis = [
    {l:'등록 차량',v:'128대'},{l:'진행 중 서류',v:'42건'},
    {l:'이번 주 선적',v:'12대'},{l:'이달 매출',v:'₩38,200,000',sm:true}
  ];
  var rows = [
    {no:'142러3821',name:'그랜저 IG',vin:'…K059327',dday:'D-312',label:'말소완료'},
    {no:'07소7215',name:'쏘나타 DN8',vin:'…H114082',dday:'D-289',label:'면장신청'},
    {no:'31가5540',name:'아반떼 CN7',vin:'…J630114',dday:'D-201',label:'선적완료'},
    {no:'86버1097',name:'스포티지 NQ5',vin:'…L227945',dday:'D-355',label:'등록완료'},
    {no:'223하6634',name:'팰리세이드 LX2',vin:'…M081226',dday:'D-330',label:'말소신청'}
  ];
  var cellNo = {width:74,flexShrink:0,fontVariantNumeric:'tabular-nums'};
  var cellName = {flex:1,minWidth:0,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'};
  var cellVin = {width:78,flexShrink:0,fontVariantNumeric:'tabular-nums'};
  var cellDday = {width:44,flexShrink:0,textAlign:'right',fontVariantNumeric:'tabular-nums'};
  var cellStatus = {width:64,flexShrink:0,display:'flex',justifyContent:'flex-end'};
  return (
    <div style={{borderRadius:16,background:'#fff',border:'1px solid #262c36',overflow:'hidden',boxShadow:'0 -10px 60px rgba(37,99,235,0.18), 0 30px 80px rgba(0,0,0,0.55)'}}>
      {/* 브라우저 크롬 */}
      <div style={{display:'flex',alignItems:'center',gap:7,background:'#e9edf2',borderBottom:'1px solid #d8dee6',padding:'10px 14px'}}>
        <span style={{width:10,height:10,borderRadius:'50%',background:'#ff5f57',flexShrink:0}}></span>
        <span style={{width:10,height:10,borderRadius:'50%',background:'#febc2e',flexShrink:0}}></span>
        <span style={{width:10,height:10,borderRadius:'50%',background:'#28c840',flexShrink:0}}></span>
        <span style={{marginLeft:10,flex:1,maxWidth:280,height:22,borderRadius:9999,background:'#fff',border:'1px solid #d8dee6',display:'flex',alignItems:'center',padding:'0 12px',fontSize:10,color:MUTE}}>autodex.kr</span>
      </div>
      <div style={{display:'flex',minHeight:300,background:'#f6f9fc',color:'#16324f'}}>
        {/* 사이드바 — 실제 admin 메뉴명 (Dashboard.js defaultMenus) */}
        <div className="lp-web-side" style={{width:152,flexShrink:0,background:NAVY,padding:'16px 12px',display:'flex',flexDirection:'column',gap:3,overflow:'hidden'}}>
          <div style={{display:'flex',alignItems:'center',gap:8,padding:'0 6px',marginBottom:12}}>
            <span style={{width:18,height:18,borderRadius:5,background:'rgba(255,255,255,0.92)',flexShrink:0}}></span>
            <span style={{fontSize:11,fontWeight:800,color:'#fff',letterSpacing:'0.02em'}}>AUTODEX</span>
          </div>
          {menus.map(function(m,i){return (
            <div key={i} style={{display:'flex',alignItems:'center',gap:8,borderRadius:8,padding:'6px 8px',background:m.on?BRAND:'transparent',whiteSpace:'nowrap'}}>
              <MenuIcon k={m.k} c={m.on?'#fff':'rgba(255,255,255,0.55)'} />
              <span style={{fontSize:11,fontWeight:m.on?700:500,color:m.on?'#fff':'rgba(255,255,255,0.68)'}}>{m.l}</span>
            </div>
          )})}
          <div style={{marginTop:'auto',display:'flex',alignItems:'center',gap:8,borderRadius:8,padding:'6px 8px',whiteSpace:'nowrap'}}>
            <MenuIcon k="gear" c="rgba(255,255,255,0.55)" />
            <span style={{fontSize:11,fontWeight:500,color:'rgba(255,255,255,0.68)'}}>설정</span>
          </div>
        </div>
        {/* 콘텐츠 */}
        <div style={{flex:1,minWidth:0,padding:'16px 18px',display:'flex',flexDirection:'column',gap:12}}>
          <div style={{display:'flex',alignItems:'center',gap:10}}>
            <span style={{fontSize:15,fontWeight:700,letterSpacing:'-0.01em',whiteSpace:'nowrap'}}>차량 목록</span>
            <span className="lp-web-hide-sm" style={{flex:1,maxWidth:210,minWidth:0,height:26,borderRadius:9999,background:'#fff',border:'1px solid '+LINE,display:'flex',alignItems:'center',gap:6,padding:'0 11px'}}>
              <SearchIcon/>
              <span style={{fontSize:10,color:'#94a3b8',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>차량번호, 차대번호 검색</span>
            </span>
            <span style={{marginLeft:'auto',background:NAVY,color:'#fff',borderRadius:9999,fontSize:10,fontWeight:700,padding:'6px 13px',whiteSpace:'nowrap'}}>+ 신규 등록</span>
          </div>
          <div className="lp-web-kpi" style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8}}>
            {kpis.map(function(k,i){return (
              <div key={i} style={{background:'#fff',border:'1px solid '+LINE,borderRadius:10,padding:'9px 11px',minWidth:0}}>
                <div style={{fontSize:9,color:MUTE,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{k.l}</div>
                <div style={{fontSize:k.sm?13.5:16,fontWeight:700,letterSpacing:'-0.02em',fontVariantNumeric:'tabular-nums',marginTop:3,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{k.v}</div>
              </div>
            )})}
          </div>
          {/* 차량 테이블 */}
          <div style={{background:'#fff',border:'1px solid '+LINE,borderRadius:10,overflow:'hidden'}}>
            <div style={{display:'flex',alignItems:'center',gap:10,padding:'7px 12px',background:'#eef2f7',borderBottom:'1px solid '+LINE,fontSize:10,color:MUTE,fontWeight:600}}>
              <span style={cellNo}>차량번호</span>
              <span style={cellName}>차명</span>
              <span className="lp-web-hide-sm" style={cellVin}>차대번호</span>
              <span className="lp-web-hide-sm" style={cellDday}>수출기한</span>
              <span style={cellStatus}>상태</span>
            </div>
            {rows.map(function(r,i){return (
              <div key={i} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 12px',fontSize:11,borderTop:i===0?'none':'1px solid #f1f5f9',background:i%2===1?'#fbfcfe':'#fff'}}>
                <span style={Object.assign({fontWeight:700,letterSpacing:'-0.01em'},cellNo)}>{r.no}</span>
                <span style={cellName}>{r.name}</span>
                <span className="lp-web-hide-sm" style={Object.assign({color:MUTE},cellVin)}>{r.vin}</span>
                <span className="lp-web-hide-sm" style={Object.assign({color:MUTE},cellDday)}>{r.dday}</span>
                <span style={cellStatus}><StatusPill label={r.label}/></span>
              </div>
            )})}
            <div style={{display:'flex',alignItems:'center',gap:10,padding:'7px 12px',borderTop:'1px solid '+LINE,background:'#fbfcfe',fontSize:10,color:MUTE}}>
              <span>총 128대</span>
              <span style={{marginLeft:'auto',display:'flex',alignItems:'center',gap:7,fontVariantNumeric:'tabular-nums'}}>
                <span>‹</span><span style={{color:BRAND,fontWeight:700}}>1</span><span>2</span><span>3</span><span>›</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { PhoneMockup, BrowserMockup };
